import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("change")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AreaSelector = _resolveComponent("AreaSelector")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AreaSelector, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      "max-level": 5,
      onSelected: _ctx.handleAreaSelected
    }, null, 8, ["modelValue", "onSelected"]),
    _createVNode(_component_AreaSelector, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event)),
      "max-level": 5
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_button, {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.value = '530100000000'))
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createTextVNode(" " + _toDisplayString(_ctx.value), 1)
  ]))
}